const TmpPE014 = (page) => {
  const modifiedPage = {
    ...page
  };
  const images = [];
  const media = [];

  // Ensure nested objects exist
  if (!modifiedPage.content) modifiedPage.content = {};
  if (!modifiedPage.content.core) modifiedPage.content.core = {};

  // Clean label (removes tabs, spaces, newlines)
  const cleanLabel = (page.label || '')
    .trim()
    .toLowerCase()
    .replaceAll('-', '_')
    .concat('.jpg');

  // Assign image_src to just template type 4
  if (page.content.core.type_id === 4) {
    const imageObject = {
      id: page.id,
      page: page.id,
      author: 'Team ACV/AAC',
      author_desc_en: 'Team ACV/AAC',
      author_desc_tl: 'N/A',
      cc_license: 'N/A',
      description: page.content.description || 'MISSING DESCRIPTION',
      downloaded_date: new Date().toISOString(),
      published_date: new Date().toISOString(),
      media_url:
        'https://base-media-repo.web.app/' +
        page.label.slice(0, 2).toUpperCase() +
        '/images/' +
        cleanLabel,
      source_url: 'Team ACV/AAC',
      size: '900px X 900px',
      src: cleanLabel,
      title_en: 'N/A',
      title_tl: 'N/A',
      type: 'image'
    };
    // Add to media array
    media.push(imageObject);

    // add to images array
    images.push(imageObject);
    // update media object of the modified page
    modifiedPage.content.core.media = imageObject;
  }

  // Extract metadata separately
  const metadata = {
    media: media || [],
    images: images || [],
    materials: [],
    eMentor: [],
    focusPoints: []
  };

  return { modifiedPage, metadata };
};

export default TmpPE014;
